import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, Modal } from '@figure/frontlib-gui';
import { PdfDocument } from 'shared/components';

const StyledBody = styled.div`
  height: calc(100vh - 52px);
  max-height: ${Math.min(document.body.offsetHeight || 800, 800)}px;

  > button {
    margin-bottom: 30px;
  }
`;

const DisclosureReviewModal = ({
  isOpen,
  header,
  documentUrl,
  buttonText,
  handleSubmit,
  handleClose,
  descriptiveTextId,
  children,
}) => (
  <Modal size="lg" isOpen={isOpen} onClose={handleClose} header={header} maxWidth="fit-content">
    <StyledBody>
      {isOpen && documentUrl && <PdfDocument file={documentUrl} style={{ height: '100%' }} />}

      {children}

      <Button
        type="button"
        primary
        large
        center
        onClick={(e) => (typeof handleSubmit === 'function' ? handleSubmit(e) : handleClose(e))}
        descriptiveTextId={descriptiveTextId}
      >
        {buttonText}
      </Button>
    </StyledBody>
  </Modal>
);

DisclosureReviewModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  header: PropTypes.string,
  documentUrl: PropTypes.string,
  handleSubmit: PropTypes.func,
  handleClose: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
  descriptiveTextId: PropTypes.string,
  children: PropTypes.node,
};

DisclosureReviewModal.defaultProps = {
  header: '',
  documentUrl: '',
  handleSubmit: null,
  buttonText: 'Close',
  descriptiveTextId: null,
  children: null,
};

export default DisclosureReviewModal;
